import { ServiceBase } from "./ServiceBase";
export class LoginServices extends ServiceBase {
    async login(url: string, body: any){
        return this.post(url, body);
    }

}